@if(!resetSuccess){

<div class="reset-container">

  <!-- Title -->
  <h1 class="main-title">Återställ lösenord</h1>
  <p class="subtitle">Ange ett nytt lösenord för ditt konto.</p>

  <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">

    <!-- PASSWORD -->
    <label class="input-label">Lösenord</label>
    <div class="input-wrapper">
  <img 
    src="../../assets/icons/lock.svg" 
    alt="" 
    class="input-icon" 
  />
  <input
    type="password"
    formControlName="password"
    placeholder="Lösenord"
    autocomplete="on"
  />
</div>

    <!-- PASSWORD RULES -->
   @if (resetPasswordForm.get('password')?.value || resetPasswordForm.get('password')?.dirty) {
    <div class="password-rules">

      <div class="rule" [class.valid]="uppercaseValid">
        <span class="icon">
          {{ uppercaseValid ? '✔' : '✖' }}
        </span>
        Minst en stor bokstav
      </div>

      <div class="rule" [class.valid]="oneDigitValid">
        <span class="icon">
          {{ oneDigitValid ? '✔' : '✖' }}
        </span>
        Minst en siffra
      </div>

      <div class="rule" [class.valid]="minLengthValid">
        <span class="icon">
          {{ minLengthValid ? '✔' : '✖' }}
        </span>
        Minst 8 karaktärer
      </div>

      <div class="rule" [class.valid]="specialCharValid">
        <span class="icon">
          {{ specialCharValid ? '✔' : '✖' }}
        </span>
        Minst ett specialtecken
      </div>
 
    </div>
 }
    <!-- CONFIRM PASSWORD -->
    <label class="input-label">Bekräfta lösenord</label>
     <div class="input-wrapper">
  <img 
    src="../../assets/icons/lock.svg" 
    alt="" 
    class="input-icon" 
  />
      <input
        type="password"
        formControlName="confirmPassword"
        placeholder="Ange lösenordet igen"
        autocomplete="on"
      />
    </div>

    <!-- ERRORS -->
    <div class="error-block">
      @if(!matchingPassword && showError){
        <span class="text-danger">
          Lösenorden måste vara likadana
        </span>
      }

      @if(requestError){
        <span class="text-danger">
          Ett oväntat fel uppstod, vänligen försök igen
        </span>
      }
    </div>

    <!-- BUTTON -->
    <button type="submit" [disabled]="btnDisabled">
      Ändra lösenord
    </button>

  </form>

</div>

}@else{

<div class="success-container">
  <p class="fw-bold">Ditt lösenord har återställts</p>
  <a [routerLink]="['/']">Logga in</a>
</div>

}